module.exports = __webpack_public_path__ + "img/order-tab-finished-active.36e75376.png";